/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { ComplianceFormRequest } from '../models';
import { FormStatusResponse } from '../models';
import { PartAFormDeclarationResponse } from '../models';
import { PartAFormOverviewResponse } from '../models';
import { PartAFormPracticeAreasRequest } from '../models';
import { PartAFormPracticeAreasResponse } from '../models';
import { PartAFormTrustAccountDetailsRequest } from '../models';
import { PartAFormTrustAccountDetailsResponse } from '../models';
import { PartAResubmissionRequestRequest } from '../models';
/**
 * PartAFormApi - axios parameter creator
 * @export
 */
export const PartAFormApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA All | Save PartA Resubmission Request
         * @param {PartAResubmissionRequestRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormAdminSavePartAResubmissionRequestPost: async (body?: PartAResubmissionRequestRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartAForm/Admin/SavePartAResubmissionRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns true when a form is successfully closed
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormClosePost: async (body?: ComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartAForm/Close`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Extend the current Form Status
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormExtendFormStatusPost: async (body?: ComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartAForm/ExtendFormStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part A Form - Overview
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormGetDeclarationPost: async (body?: ComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartAForm/GetDeclaration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Returns Part A Form Status
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormGetFormStatusComplianceFormIdGet: async (complianceFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV2PartAFormGetFormStatusComplianceFormIdGet.');
            }
            const localVarPath = `/api/v2/PartAForm/GetFormStatus/{complianceFormId}`
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part A Form - Overview
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormGetOverviewPost: async (body?: ComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartAForm/GetOverview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part A Form - Practice Areas
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormGetPracticeAreasPost: async (body?: ComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartAForm/GetPracticeAreas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part A Form - Trust Account Details
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormGetTrustAccountDetailsPost: async (body?: ComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartAForm/GetTrustAccountDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Kick out the current opened Form Status
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormKickOutFormStatusComplianceFormIdGet: async (complianceFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV2PartAFormKickOutFormStatusComplianceFormIdGet.');
            }
            const localVarPath = `/api/v2/PartAForm/KickOutFormStatus/{complianceFormId}`
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part A Form - Practice Areas Responses
         * @param {PartAFormPracticeAreasRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormSavePracticeAreasPost: async (body?: PartAFormPracticeAreasRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartAForm/SavePracticeAreas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part A Form - Trust Account Details Responses
         * @param {PartAFormTrustAccountDetailsRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormSaveTrustAccountDetailsPost: async (body?: PartAFormTrustAccountDetailsRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartAForm/SaveTrustAccountDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal | Submit Part A Form
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormSubmitFormPost: async (body?: ComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PartAForm/SubmitForm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartAFormApi - functional programming interface
 * @export
 */
export const PartAFormApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA All | Save PartA Resubmission Request
         * @param {PartAResubmissionRequestRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartAFormAdminSavePartAResubmissionRequestPost(body?: PartAResubmissionRequestRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PartAFormApiAxiosParamCreator(configuration).apiV2PartAFormAdminSavePartAResubmissionRequestPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns true when a form is successfully closed
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartAFormClosePost(body?: ComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PartAFormApiAxiosParamCreator(configuration).apiV2PartAFormClosePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Extend the current Form Status
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartAFormExtendFormStatusPost(body?: ComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PartAFormApiAxiosParamCreator(configuration).apiV2PartAFormExtendFormStatusPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part A Form - Overview
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartAFormGetDeclarationPost(body?: ComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartAFormDeclarationResponse>> {
            const localVarAxiosArgs = await PartAFormApiAxiosParamCreator(configuration).apiV2PartAFormGetDeclarationPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Returns Part A Form Status
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartAFormGetFormStatusComplianceFormIdGet(complianceFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormStatusResponse>> {
            const localVarAxiosArgs = await PartAFormApiAxiosParamCreator(configuration).apiV2PartAFormGetFormStatusComplianceFormIdGet(complianceFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part A Form - Overview
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartAFormGetOverviewPost(body?: ComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartAFormOverviewResponse>> {
            const localVarAxiosArgs = await PartAFormApiAxiosParamCreator(configuration).apiV2PartAFormGetOverviewPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part A Form - Practice Areas
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartAFormGetPracticeAreasPost(body?: ComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartAFormPracticeAreasResponse>> {
            const localVarAxiosArgs = await PartAFormApiAxiosParamCreator(configuration).apiV2PartAFormGetPracticeAreasPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part A Form - Trust Account Details
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartAFormGetTrustAccountDetailsPost(body?: ComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartAFormTrustAccountDetailsResponse>> {
            const localVarAxiosArgs = await PartAFormApiAxiosParamCreator(configuration).apiV2PartAFormGetTrustAccountDetailsPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Kick out the current opened Form Status
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartAFormKickOutFormStatusComplianceFormIdGet(complianceFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PartAFormApiAxiosParamCreator(configuration).apiV2PartAFormKickOutFormStatusComplianceFormIdGet(complianceFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part A Form - Practice Areas Responses
         * @param {PartAFormPracticeAreasRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartAFormSavePracticeAreasPost(body?: PartAFormPracticeAreasRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PartAFormApiAxiosParamCreator(configuration).apiV2PartAFormSavePracticeAreasPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part A Form - Trust Account Details Responses
         * @param {PartAFormTrustAccountDetailsRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartAFormSaveTrustAccountDetailsPost(body?: PartAFormTrustAccountDetailsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PartAFormApiAxiosParamCreator(configuration).apiV2PartAFormSaveTrustAccountDetailsPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal | Submit Part A Form
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PartAFormSubmitFormPost(body?: ComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PartAFormApiAxiosParamCreator(configuration).apiV2PartAFormSubmitFormPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PartAFormApi - factory interface
 * @export
 */
export const PartAFormApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary TA All | Save PartA Resubmission Request
         * @param {PartAResubmissionRequestRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormAdminSavePartAResubmissionRequestPost(body?: PartAResubmissionRequestRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PartAFormApiFp(configuration).apiV2PartAFormAdminSavePartAResubmissionRequestPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns true when a form is successfully closed
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormClosePost(body?: ComplianceFormRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PartAFormApiFp(configuration).apiV2PartAFormClosePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Extend the current Form Status
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormExtendFormStatusPost(body?: ComplianceFormRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PartAFormApiFp(configuration).apiV2PartAFormExtendFormStatusPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part A Form - Overview
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormGetDeclarationPost(body?: ComplianceFormRequest, options?: any): AxiosPromise<PartAFormDeclarationResponse> {
            return PartAFormApiFp(configuration).apiV2PartAFormGetDeclarationPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Returns Part A Form Status
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormGetFormStatusComplianceFormIdGet(complianceFormId: number, options?: any): AxiosPromise<FormStatusResponse> {
            return PartAFormApiFp(configuration).apiV2PartAFormGetFormStatusComplianceFormIdGet(complianceFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part A Form - Overview
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormGetOverviewPost(body?: ComplianceFormRequest, options?: any): AxiosPromise<PartAFormOverviewResponse> {
            return PartAFormApiFp(configuration).apiV2PartAFormGetOverviewPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part A Form - Practice Areas
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormGetPracticeAreasPost(body?: ComplianceFormRequest, options?: any): AxiosPromise<PartAFormPracticeAreasResponse> {
            return PartAFormApiFp(configuration).apiV2PartAFormGetPracticeAreasPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Returns Part A Form - Trust Account Details
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormGetTrustAccountDetailsPost(body?: ComplianceFormRequest, options?: any): AxiosPromise<PartAFormTrustAccountDetailsResponse> {
            return PartAFormApiFp(configuration).apiV2PartAFormGetTrustAccountDetailsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Kick out the current opened Form Status
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormKickOutFormStatusComplianceFormIdGet(complianceFormId: number, options?: any): AxiosPromise<BooleanResponse> {
            return PartAFormApiFp(configuration).apiV2PartAFormKickOutFormStatusComplianceFormIdGet(complianceFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part A Form - Practice Areas Responses
         * @param {PartAFormPracticeAreasRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormSavePracticeAreasPost(body?: PartAFormPracticeAreasRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PartAFormApiFp(configuration).apiV2PartAFormSavePracticeAreasPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact | Save Part A Form - Trust Account Details Responses
         * @param {PartAFormTrustAccountDetailsRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormSaveTrustAccountDetailsPost(body?: PartAFormTrustAccountDetailsRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PartAFormApiFp(configuration).apiV2PartAFormSaveTrustAccountDetailsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal | Submit Part A Form
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartAFormSubmitFormPost(body?: ComplianceFormRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PartAFormApiFp(configuration).apiV2PartAFormSubmitFormPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PartAFormApi - object-oriented interface
 * @export
 * @class PartAFormApi
 * @extends {BaseAPI}
 */
export class PartAFormApi extends BaseAPI {
    /**
     * 
     * @summary TA All | Save PartA Resubmission Request
     * @param {PartAResubmissionRequestRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartAFormApi
     */
    public apiV2PartAFormAdminSavePartAResubmissionRequestPost(body?: PartAResubmissionRequestRequest, options?: any) {
        return PartAFormApiFp(this.configuration).apiV2PartAFormAdminSavePartAResubmissionRequestPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Returns true when a form is successfully closed
     * @param {ComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartAFormApi
     */
    public apiV2PartAFormClosePost(body?: ComplianceFormRequest, options?: any) {
        return PartAFormApiFp(this.configuration).apiV2PartAFormClosePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact  | Extend the current Form Status
     * @param {ComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartAFormApi
     */
    public apiV2PartAFormExtendFormStatusPost(body?: ComplianceFormRequest, options?: any) {
        return PartAFormApiFp(this.configuration).apiV2PartAFormExtendFormStatusPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Returns Part A Form - Overview
     * @param {ComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartAFormApi
     */
    public apiV2PartAFormGetDeclarationPost(body?: ComplianceFormRequest, options?: any) {
        return PartAFormApiFp(this.configuration).apiV2PartAFormGetDeclarationPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact  | Returns Part A Form Status
     * @param {number} complianceFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartAFormApi
     */
    public apiV2PartAFormGetFormStatusComplianceFormIdGet(complianceFormId: number, options?: any) {
        return PartAFormApiFp(this.configuration).apiV2PartAFormGetFormStatusComplianceFormIdGet(complianceFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Returns Part A Form - Overview
     * @param {ComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartAFormApi
     */
    public apiV2PartAFormGetOverviewPost(body?: ComplianceFormRequest, options?: any) {
        return PartAFormApiFp(this.configuration).apiV2PartAFormGetOverviewPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Returns Part A Form - Practice Areas
     * @param {ComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartAFormApi
     */
    public apiV2PartAFormGetPracticeAreasPost(body?: ComplianceFormRequest, options?: any) {
        return PartAFormApiFp(this.configuration).apiV2PartAFormGetPracticeAreasPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Returns Part A Form - Trust Account Details
     * @param {ComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartAFormApi
     */
    public apiV2PartAFormGetTrustAccountDetailsPost(body?: ComplianceFormRequest, options?: any) {
        return PartAFormApiFp(this.configuration).apiV2PartAFormGetTrustAccountDetailsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact  | Kick out the current opened Form Status
     * @param {number} complianceFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartAFormApi
     */
    public apiV2PartAFormKickOutFormStatusComplianceFormIdGet(complianceFormId: number, options?: any) {
        return PartAFormApiFp(this.configuration).apiV2PartAFormKickOutFormStatusComplianceFormIdGet(complianceFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Save Part A Form - Practice Areas Responses
     * @param {PartAFormPracticeAreasRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartAFormApi
     */
    public apiV2PartAFormSavePracticeAreasPost(body?: PartAFormPracticeAreasRequest, options?: any) {
        return PartAFormApiFp(this.configuration).apiV2PartAFormSavePracticeAreasPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact | Save Part A Form - Trust Account Details Responses
     * @param {PartAFormTrustAccountDetailsRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartAFormApi
     */
    public apiV2PartAFormSaveTrustAccountDetailsPost(body?: PartAFormTrustAccountDetailsRequest, options?: any) {
        return PartAFormApiFp(this.configuration).apiV2PartAFormSaveTrustAccountDetailsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal | Submit Part A Form
     * @param {ComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartAFormApi
     */
    public apiV2PartAFormSubmitFormPost(body?: ComplianceFormRequest, options?: any) {
        return PartAFormApiFp(this.configuration).apiV2PartAFormSubmitFormPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
